import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';

export default function MerciRDV() {
  const navigate = useNavigate();
  const [showContent, setShowContent] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
    const timer = setTimeout(() => setShowContent(true), 100);

    // Inject iClosed widget script
    if (!document.querySelector('script[src="https://app.iclosed.io/assets/widget.js"]')) {
      const script = document.createElement('script');
      script.src = 'https://app.iclosed.io/assets/widget.js';
      script.async = true;
      document.body.appendChild(script);
    }

    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-screen bg-gradient-to-b from-gray-950 via-gray-900 to-gray-950 text-white">
      <meta name="robots" content="noindex, nofollow" />
      {/* Navbar */}
      <nav className="w-full py-6">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex justify-center">
          <a
            href="/"
            onClick={(e) => {
              e.preventDefault();
              navigate('/');
            }}
            className="cursor-pointer"
          >
            <img
              src="https://static.readdy.ai/image/857147547f7da499a0fc7d35aaf6d8ec/512cce5c00ccd36955d2d4e00fd25839.png"
              alt="Usine à Leads"
              className="h-10 w-auto"
            />
          </a>
        </div>
      </nav>

      {/* Contenu principal */}
      <main
        className={`max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-8 sm:py-12 transition-all duration-700 ${
          showContent ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'
        }`}
      >
        {/* Confirmation RDV */}
        <section className="text-center mb-10 sm:mb-14">
          <div className="inline-flex items-center justify-center w-20 h-20 rounded-full bg-emerald-500/20 mb-6">
            <i className="ri-calendar-check-fill text-4xl text-emerald-400"></i>
          </div>
          <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold mb-4 leading-tight">
            Votre rendez-vous est confirmé&nbsp;!
          </h1>
          <p className="text-lg sm:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed">
            Merci d&apos;avoir réservé un appel avec notre équipe. Nous avons hâte d&apos;échanger avec vous&nbsp;!
          </p>
        </section>

        {/* iClosed Widget */}
        <section className="mb-10 sm:mb-14">
          <div
            className="call-details-widget"
            data-url="https://app.iclosed.io/embed"
            style={{ width: '100%', height: '340px' }}
          />
        </section>

        {/* Section préparation */}
        <section className="mb-10 sm:mb-14">
          <div className="bg-gradient-to-br from-white/5 to-white/[0.02] rounded-2xl border border-white/10 p-6 sm:p-10">
            <div className="flex items-start gap-4 mb-6">
              <div className="w-12 h-12 rounded-xl bg-orange-500/20 flex items-center justify-center flex-shrink-0">
                <i className="ri-lightbulb-flash-line text-2xl text-orange-400"></i>
              </div>
              <div>
                <h2 className="text-xl sm:text-2xl font-bold mb-2">
                  Préparez votre rendez-vous
                </h2>
                <p className="text-white/60 leading-relaxed">
                  En attendant notre appel, prenez quelques minutes pour réfléchir à vos besoins. Plus vous serez préparé, plus notre échange sera bénéfique pour vous.
                </p>
              </div>
            </div>

            {/* Questions à se poser */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-white/90 flex items-center gap-2">
                <i className="ri-question-line text-orange-400"></i>
                Questions à vous poser avant le RDV
              </h3>
              <ul className="space-y-3">
                <li className="flex items-start gap-3 text-white/70">
                  <i className="ri-checkbox-circle-line text-emerald-400 mt-0.5 flex-shrink-0"></i>
                  <span>Quels sont vos objectifs de croissance pour les 6 prochains mois&nbsp;?</span>
                </li>
                <li className="flex items-start gap-3 text-white/70">
                  <i className="ri-checkbox-circle-line text-emerald-400 mt-0.5 flex-shrink-0"></i>
                  <span>Combien de leads qualifiés souhaitez-vous générer par mois&nbsp;?</span>
                </li>
                <li className="flex items-start gap-3 text-white/70">
                  <i className="ri-checkbox-circle-line text-emerald-400 mt-0.5 flex-shrink-0"></i>
                  <span>Quel est votre budget marketing actuel et envisagé&nbsp;?</span>
                </li>
                <li className="flex items-start gap-3 text-white/70">
                  <i className="ri-checkbox-circle-line text-emerald-400 mt-0.5 flex-shrink-0"></i>
                  <span>Quels canaux d&apos;acquisition utilisez-vous actuellement&nbsp;?</span>
                </li>
                <li className="flex items-start gap-3 text-white/70">
                  <i className="ri-checkbox-circle-line text-emerald-400 mt-0.5 flex-shrink-0"></i>
                  <span>Quels sont vos principaux défis pour convertir vos prospects&nbsp;?</span>
                </li>
              </ul>
            </div>
          </div>
        </section>

        {/* Video Placeholder */}
        <section className="mb-10 sm:mb-14">
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-bold mb-3">
              Découvrez notre méthode
            </h2>
            <p className="text-white/60 max-w-xl mx-auto">
              En attendant votre rendez-vous, regardez cette vidéo pour comprendre comment nous générons des leads qualifiés pour nos clients.
            </p>
          </div>
          <div
            className="relative w-full rounded-2xl overflow-hidden shadow-2xl shadow-orange-500/10 border border-white/10 bg-gray-800"
            style={{ aspectRatio: '16/9' }}
          >
            <div className="absolute inset-0 flex flex-col items-center justify-center gap-4">
              <div className="w-20 h-20 rounded-full bg-orange-500/20 flex items-center justify-center cursor-pointer hover:bg-orange-500/30 transition-all duration-300 group">
                <i className="ri-play-fill text-4xl text-orange-400 group-hover:text-orange-300 ml-1"></i>
              </div>
              <p className="text-white/50 text-sm font-medium">Vidéo à venir</p>
            </div>
          </div>
        </section>

        {/* Ce que vous allez découvrir */}
        <section className="mb-16 sm:mb-20">
          <div className="grid sm:grid-cols-3 gap-4 sm:gap-6">
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 hover:border-orange-500/30 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-orange-500/20 flex items-center justify-center mb-4">
                <i className="ri-target-line text-2xl text-orange-400"></i>
              </div>
              <h3 className="font-bold text-lg mb-2">Stratégie sur-mesure</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Nous analyserons ensemble votre marché et définirons une stratégie adaptée à vos objectifs.
              </p>
            </div>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 hover:border-emerald-500/30 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-emerald-500/20 flex items-center justify-center mb-4">
                <i className="ri-line-chart-line text-2xl text-emerald-400"></i>
              </div>
              <h3 className="font-bold text-lg mb-2">Projections réalistes</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Vous repartirez avec des estimations concrètes de résultats basées sur votre secteur.
              </p>
            </div>
            <div className="bg-white/5 rounded-xl p-6 border border-white/10 hover:border-teal-500/30 transition-all duration-300">
              <div className="w-12 h-12 rounded-lg bg-teal-500/20 flex items-center justify-center mb-4">
                <i className="ri-roadmap-line text-2xl text-teal-400"></i>
              </div>
              <h3 className="font-bold text-lg mb-2">Plan d&apos;action clair</h3>
              <p className="text-white/60 text-sm leading-relaxed">
                Un roadmap détaillé pour lancer votre machine à leads en quelques semaines.
              </p>
            </div>
          </div>
        </section>

        {/* Rappel */}
        <section className="text-center mb-10">
          <div className="inline-flex items-center gap-3 bg-white/5 rounded-full px-6 py-3 border border-white/10">
            <i className="ri-notification-3-line text-orange-400"></i>
            <span className="text-white/70 text-sm">
              Vous recevrez un email de confirmation avec les détails du rendez-vous
            </span>
          </div>
        </section>
      </main>

      {/* Footer */}
      <footer className="border-t border-white/10 py-6">
        <div className="max-w-7xl mx-auto px-4 text-center text-xs text-white/40">
          © {new Date().getFullYear()} Usine à Leads. Tous droits réservés.
        </div>
      </footer>
    </div>
  );
}
